<template>
  <!-- prettier-ignore -->
  <div :class="classes">
    <div
      class="protection__head"
      @click="toggle">
      <span
        class="protection__title"
        v-text="title"
      />
      <ovp-icon
        v-show="toggleable"
        art="light"
        :name="show ? 'angle-up' : 'angle-down'"
      />
    </div>
    <transition>
      <span
        v-if="show"
        class="protection__bottom">
        <slot></slot>
      </span>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Protection',

  props: {
    title: {
      type: String,
      required: true,
    },

    toggleable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      show: true,
    }
  },

  computed: {
    classes() {
      return {
        protection: true,
        'protection--toggleable': this.toggleable,
      }
    },
  },

  methods: {
    toggle() {
      if (this.toggleable) {
        this.show = !this.show
      }
    },
  },
}
</script>

<style name="mobile" scoped>
.protection {
  &__title {
    font-size: 12px;
    line-height: 15px;
    color: #666;
    font-weight: bold;
    margin-bottom: 10px;
  }

  &__head {
    display: flex;

    :first-child {
      margin: auto auto auto 0;
    }
    :last-child {
      margin: auto 0 3px auto;
    }
  }

  &__bottom {
    font-size: 12px;
    color: var(--c-black);
  }

  &--toggleable {
    cursor: pointer;
  }
}
</style>
